import styled from "styled-components";

import { UserContainer } from "../User/UserStyles";

export const Sidebar = styled.div`
  background-color: ${(props) => props.theme.colors.white};
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
  padding-bottom: 3rem;
  padding-top: 3rem;
  width: 100%;
  p {
    font-size: 1.2rem;
    font-weight: 700;
    text-align: center;
  }
`;

export const ScreenContainer = styled.div`
  ${(props) => `background-color: ${props.theme.colors.backgroundBlue};`}
  display: grid;
  grid-template-rows: 1fr 9fr;
  height: 100vh;
  overflow-x: hidden;
  overflow-y: auto;
  position: relative;
  width: 100%;
`;

export const MainButton = styled.button`
  ${(props) => `
  background-color: ${props.theme.colors.accentRed};
  color: ${props.theme.colors.white};
  font-family: ${props.theme.fontFamilies.primaryFont};
  `}
  align-items: center;
  border-radius: 0.8rem;
  border: none;
  cursor: pointer;
  display: flex;
  font-size: 1.7rem;
  font-weight: 700;
  justify-content: center;
  margin: auto;
  min-height: 5rem;
  width: 17.5rem;
`;

export const ExchangeRate = styled.div`
  display: flex;
  font-size: 1.2rem;
  font-weight: 700;
  justify-content: center;
  margin-bottom: 2rem;
  width: 100%;
`;

export const CurrencySwitch = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 2rem;
  width: 100%;
  .switch-label {
    font-size: 1.4rem;
    font-weight: 700;
    margin-right: 1rem;
  }
`;

export const VersionDiv = styled.div`
  color: ${(props) => props.theme.colors.gray};
  margin-top: 1rem;
  text-align: center;
`;

export const SessionDiv = styled.div`
  font-weight: 700;
  margin-bottom: 2rem;
  text-align: center;
  margin-top: 6rem;
`;

export const Navbar = styled.div`
  background: ${(props) => props.theme.colors.white};
  display: flex;
  justify-content: space-between;
  position: fixed;
  width: 100%;
  z-index: 5;

  .navbar-button {
    background: transparent;
    border-color: transparent;
    cursor: pointer;
    display: block;
  }

  ${UserContainer} {
    align-items: center;
    flex-direction: row;
    gap: 0.5rem;

    img {
      height: 5rem;
    }

    h1 {
      font-size: 1.1rem;
      margin-bottom: 0.5rem;
    }
  }
`;

export const SidebarChildContainer = styled.div`
  background-color: ${(props) => props.theme.colors.white};
  border-radius: 1rem;
  font-family: ${(props) => props.theme.fontFamilies.primaryFont};
  font-size: 1.4rem;
  height: 100vh;
  width: 23rem;
`;

interface IGlobalContainer {
  maxWidth?: string;
}
export const GlobalContainer = styled.div<IGlobalContainer>`
  display: grid;
  grid-template-columns: 21rem 1fr;

  @media (max-width: ${(props) => props.maxWidth}) {
    display: block;

    ${ScreenContainer} {
      padding-top: 2rem;
    }
  }
`;
